import React, { useEffect, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import CustomFormInput from '../CustomFormInput'
import { SkillValidation } from '../../validate/skillValidation';
import ErrorFilter from '../../helper/errorFilter';
import { addActivityList, editActivityList, getAllCategoryList } from '../../controller';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { requestHandler } from '../../helper';
import SingleError from '../../helper/SingleError';
import Select from 'react-select';

function AddActivityModal({ show, getActivityData, setShowActivity, activityData, id, setId, setSelectedActivity, page }) {

  const requiredField = ["title", "categoryId"];
  const [errors, setErrors] = useState({});

  const [submitCount, setSubmitCount] = useState(0);
  const [category, setCategory] = useState([]);
  // const [loading, setLoading] = useState(true);


  const navigate = useNavigate();
  const selectedCategory = category.map((item) => ({ value: item._id, label: item.title }));
  const handleClose = () => {
    setId(null);
    setSelectedActivity({})
    setShowActivity(false);
    if (!activityData) {
      setSkill({ title: "", categoryId: null });
    }
    setErrors({});
  }
  const [skill, setSkill] = useState({
    title: "",
    categoryId: null
  })


  useEffect(() => {
    if (show) {
      getCategory();
      // Reset skill state based on activityData
      if (!activityData || Object.keys(activityData).length === 0) {
        setSkill({ title: "", categoryId: null });
      } else {
        setSkill({
          title: activityData.title || "",
          categoryId: activityData.categoryId?.title || null
        });
      }
    }
  }, [show, activityData]);


  useEffect(() => {
    getCategory();
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (submitCount > 0) {
      let validationError = SkillValidation({
        ...skill,
        [name]: value
      });
      validationError = ErrorFilter(validationError, requiredField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors[name];
      }
    }
    setSkill({ ...skill, [name]: value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSubmitCount(prevCount => prevCount + 1);
    const updateValues = { ...skill };

    // Only include categoryId in the payload if it has changed
    if (activityData && skill.categoryId === activityData.categoryId?.title) {
      delete updateValues.categoryId;  // Remove categoryId if it hasn't changed
    }
    let validationErrors = SkillValidation(updateValues);
    validationErrors = ErrorFilter(validationErrors, requiredField);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      await requestHandler(
        async () => {
          if (id) {
            return await editActivityList(updateValues, id);
          } else {
            return await addActivityList(updateValues);
          }
        },
        null,
        (res) => {
          toast.success(res.message);
          navigate("/category-management");
          getActivityData(page);
          handleClose();
        },
        () => { }
      );
    }
  };

  const handleSelectChange = (selectedOption, field) => {
    if (submitCount > 0) {
      let validationError = SkillValidation({
        ...skill, [field]: selectedOption ? selectedOption.value : ""
      })

      validationError = ErrorFilter(validationError, requiredField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors[field];
      }
    }
    setSkill({ ...skill, [field]: selectedOption ? selectedOption.value : "" });
  };

  const getCategory = async () => {
    // setLoading(true);
    await requestHandler(
      async () => {
        return await getAllCategoryList();
      },
      null,
      (res) => {
        setCategory(res.data);
        // setLoading(false);
      },
      () => { }
    );
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>{activityData?._id ? "Edit Activity Level" : "Add New Activity Level"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomFormInput
          type="text"
          label="Activity Title"
          placeholder="Enter activity title"
          id="title"
          name="title"
          value={activityData?._id && skill.title}
          onChange={handleChange}
        />
        <SingleError error={errors.title} />

        <div className='theme-select theme-input'>
          <Form.Label>Category Type</Form.Label>
          <Select
            name="categoryId"
            options={selectedCategory}
            value={selectedCategory.find(option => option.label
              === skill.categoryId || null)}
            onChange={(selectedOption) => handleSelectChange(selectedOption, 'categoryId')}
            className="basic-multi-select"
          />
        </div>
        <SingleError error={errors.categoryId} />
        <div className="d-sm-flex align-items-center gap-sm-4 gap-2">
          <button onClick={handleClose} className="btn btn-outline-light w-100">
            Cancel
          </button>
          <button className="btn btn-primary w-100 mt-sm-0 mt-2" type="button" onClick={handleSave}>
            {activityData ? "Save Changes" : "Add New Activity"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AddActivityModal